































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import userSettings from "@/components/userSettings.vue";
import teamChange from "@/components/teamChange.vue";
import reviewSubmissions from "@/components/review/reviewSubmissions.vue";
import consts from "@/consts";
import { percentFromTotal } from "@/utils";
import { User, UserStat, ReviewType, Rubric, Team, Role } from "@/types";
import axios from "axios";
import { Getter } from "vuex-class";

@Component({
  components: {
    userSettings,
    teamChange,
    reviewSubmissions
  }
})
export default class Review extends Vue {
  @Prop() private changeTeam!: (teamID: any) => any;
  @Getter private currentTeamID?: string;
  @Getter private currentTeam!: Team;
  
  private reviewRequired: ReviewType = ReviewType.ReviewRequired;
  private alreadyReviewed: ReviewType = ReviewType.AlreadyReviewed;
  private managerRole: Role = Role.Manager;
  private enterpriseAdminRole: Role = Role.EnterpriseAdmin;

    private manageRubric() {
    if (this.currentTeamID) {
      this.$router.push({
        name: "manageRubric",
        params: {
          teamID: this.currentTeamID
        }
      });
    }
  }

  private configureReviewers() {
    if (this.currentTeamID) {
      this.$router.push({
        name: "configureReviewers",
        params: {
          teamID: this.currentTeamID
        }
      });
    }
  }
}
